module.exports = __webpack_public_path__ + "static/media/EMS_9287.0c104087.jpg";